import { Endpoints } from 'UI/constants/endpoints';

import API from './API';

export const createRestrictionRequest = data => API.post(Endpoints.Restrictions, data);
